import WarningAmberIcon from '@mui/icons-material/WarningAmber';
import { Box } from '@mui/material';
import { useFormContext } from 'framework/form';
import { StatusType } from '../../availabilityUser/constants';

const FOCUS_WARNING_SX = {
  alignItems: 'center',
  color: 'text.error',
  display: 'flex',
  fontSize: 12,
  gap: 0.75,
  lineHeight: 1.45,
} as const;

const FocusedEmergencyCallWarning = () => {
  const { data } = useFormContext();
  const shouldShowWarning = data?.recipient?.state === StatusType.FOCUSED;

  if (!shouldShowWarning) {
    return null;
  }

  return (
    <Box sx={FOCUS_WARNING_SX}>
      <WarningAmberIcon color="error" fontSize="small" />
      <Box component="span">This person is in Focus mode. Do you still want to call them?</Box>
    </Box>
  );
};

export default FocusedEmergencyCallWarning;
